import { T } from '@deltachat/jsonrpc-client'

// `webimap` is added by the regenerated local jsonrpc bindings; the published
// 2.53.0 package does not have it yet, so widen locally to keep tsc green.
export type Credentials = T.EnteredLoginParam & { webimap?: boolean | null }

export type ProxySettings = {
  proxyEnabled: boolean
  proxyUrl: string | null
}

export enum Proxy {
  DISABLED = '0',
  ENABLED = '1',
}

export function defaultCredentials(credentials?: Credentials): Credentials {
  const defaultCredentials: Credentials = {
    addr: '',
    imapUser: null,
    password: '',
    imapServer: null,
    imapPort: null,
    imapFolder: null,
    imapSecurity: null,
    certificateChecks: null,
    smtpUser: null,
    smtpPassword: null,
    smtpServer: null,
    smtpPort: null,
    smtpSecurity: null,
    oauth2: null,
    webimap: null,
  }

  return { ...defaultCredentials, ...credentials }
}
